import { Link } from 'react-router-dom';
import { Linkedin, Facebook, Instagram, Mail } from 'lucide-react';
import { BRAND, FOOTER_LINKS, SOCIAL_LINKS } from '../data/mock';

const LOGO_ICON = 'https://customer-assets-v7afamib.emergentagent.net/job_whatsapp-api-hub-13/artifacts/5ocw3vic_ChatGPT%20Image%20Jul%209%2C%202026%2C%2001_28_40%20PM.png';

const SOCIALS = [
  { Icon: Instagram, href: SOCIAL_LINKS.instagram, label: 'Instagram' },
  { Icon: Facebook, href: SOCIAL_LINKS.facebook, label: 'Facebook' },
  { Icon: Linkedin, href: SOCIAL_LINKS.linkedin, label: 'LinkedIn' },
  { Icon: Mail, href: SOCIAL_LINKS.email, label: 'Email' },
];

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8">
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-3">
              <img src={LOGO_ICON} alt="ACTIWA" className="w-11 h-11 rounded-xl" />
              <span className="text-2xl font-extrabold tracking-tight text-white">
                {BRAND.name}
              </span>
            </Link>
            <p className="mt-4 text-sm text-slate-400 max-w-xs leading-relaxed">
              AI-powered WhatsApp automation platform that helps businesses engage, convert and grow.
            </p>
            <p className="mt-2 text-xs text-brand-green font-semibold tracking-wider">
              AUTOMATE • CONNECT • GROW
            </p>
            <div className="mt-6 flex items-center gap-3">
              {SOCIALS.map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                  className="w-9 h-9 grid place-items-center rounded-full bg-slate-800 hover:bg-brand-purple hover:text-white transition-colors"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>

            <div className="mt-6 space-y-1.5 text-xs text-slate-400">
              <p>
                <a href={`mailto:${BRAND.email}`} className="hover:text-brand-green">
                  {BRAND.email}
                </a>
              </p>
              <p>+91 {BRAND.phone}</p>
            </div>
          </div>

          {Object.entries(FOOTER_LINKS).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-white font-semibold text-sm mb-4">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-sm text-slate-400 hover:text-brand-green transition-colors"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">
            © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </p>
          <p className="text-sm text-slate-500">
            Made for businesses • {BRAND.domain}
          </p>
        </div>
      </div>
    </footer>
  );
}
